import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";



const SdpServiceCreate = ()=>{
    const [clientList, setClientList] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`client?page=${page}`);
            console.log(data);
            setClientList(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);

    const [serviceTypeList, setServiceTypeList] = useState([]); 
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`serviceType?page=${page}`);
            setServiceTypeList(data.data); 

        }
        )();
    },[page]);

     const [serviceName, setServiceName ] = useState('');
     const [shortCode, setShortCode ] = useState('');
     const [offerCode, setOfferCode ] = useState('');
     const [cost, setCost ] = useState('');
     const [keyword, setKeyword ] = useState('');
     const [client, setClient ] = useState(1);
     const [serviceType, setServiceType ] = useState('');
     const [clientInputUrl, setClientInputUrl ] = useState('');
     const [clientDlrUrl, setClientDlrUrl ] = useState('');
     const [sdpInputUrl, setSdpInputUrl ] = useState('');
     const [sdpDlrUrl, setSdpDlrUrl ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         if(client === ""){
            setClient(1);
         }
         const {data} = await axios.post('sdpService', {
            service_name:serviceName,
            short_code:shortCode,
            offer_code:offerCode,
            cost:parseFloat(cost),
            keyword,
            client_id:parseInt(client, 10),
            service_type_id:parseInt(serviceType),
            client_input_url:clientInputUrl,
            client_dlr_url:clientDlrUrl,
            sdp_input_url:sdpInputUrl,
            sdp_dlr_url:sdpDlrUrl, 
        });
        console.log("Client:" + client + ", Service Type:" + serviceType);
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/sdpService'} />
    }
 

     return (
         <Wrapper pageTitle={"New SdpService"}>
            <InnerNav createLink={'/sdpServiceCreate'} listLink={'/sdpService'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ServiceName </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ServiceName"
                        onChange = {e => setServiceName(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ShortCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ShortCode"
                        onChange = {e => setShortCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">OfferCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="OfferCode"
                        onChange = {e => setOfferCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Cost </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Cost"
                        onChange = {e => setCost(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Keyword </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Keyword"
                        onChange = {e => setKeyword(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Client </span>
                        {/* <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Client"
                        onChange = {e => setClient(e.target.value)} /> */}
                        <select onChange={(e) => setClient(e.target.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input ">
                            <option value="0">Choose Client</option>
                            {clientList.map(client => (
                                <option key={client.id} value={client.id}>
                                    {client.name}
                                </option>
                            ))}
                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Service Type </span>
                        {/* <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Client"
                        onChange = {e => setClient(e.target.value)} /> */}
                        <select onChange={(e) => setServiceType(e.target.value)}  className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input ">
                        <option value="0">Choose Service Type</option>
                            {serviceTypeList.map(serviceType => (
                                <option key={serviceType.id} value={serviceType.id}>
                                    {serviceType.name}
                                </option>
                            ))}
                        </select>
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ClientInputUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ClientInputUrl"
                        onChange = {e => setClientInputUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">ClientDlrUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="ClientDlrUrl"
                        onChange = {e => setClientDlrUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SdpInputUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SdpInputUrl"
                        onChange = {e => setSdpInputUrl(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">SdpDlrUrl </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="SdpDlrUrl"
                        onChange = {e => setSdpDlrUrl(e.target.value)} />
                    </label>

                 

                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default SdpServiceCreate;